<template>
  <header class="header">
    <nav class="navbar has-shadow is-primary" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <router-link id="logo" class="navbar-item" :to="{name: 'Presence'}">CogaaWS</router-link>

        <a role="button" class="navbar-burger" data-target="main-menu" aria-label="menu"
           aria-expanded="false">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <navigation-menu></navigation-menu>
    </nav>
  </header>
</template>

<script>
/**
 * Warning: this is a PARTIAL copy of "abcstrategie/cogaa" project's file.
 * Each update of the main project should be manually made.
 */
import NavigationMenu from './NavigationMenu'

document.addEventListener('DOMContentLoaded', function () {
  // Get all "navbar-burger" elements
  let $navbarBurgers = Array.prototype.slice.call(
    document.querySelectorAll('.navbar-burger'), 0
  )
  // Check if there are any navbar burgers
  if ($navbarBurgers.length > 0) {
    // Add a click event on each of them
    $navbarBurgers.forEach(function ($el) {
      $el.addEventListener('click', function () {
        // Get the target from the "data-target" attribute
        let target = $el.dataset.target
        let $target = document.getElementById(target)
        // Toggle the class on both the "navbar-burger" and the "navbar-menu"
        $el.classList.toggle('is-active')
        $target.classList.toggle('is-active')
      })
    })
  }

  // Get all "navbar-item" elements
  let $navbarItems = Array.prototype.slice.call(
    document.querySelectorAll('.navbar-item'), 0
  )

  // Check if there are any navbar items
  if ($navbarItems.length > 0) {
    // Add a click event on each of them
    $navbarItems.forEach(function ($el) {
      $el.addEventListener('click', function () {
        let target = $el.offsetParent.querySelectorAll('.navbar-menu')
        if (target.length > 0) {
          let $target = document.getElementById(target[0].id)
          // Toggle the class on both the "navbar-item" and the "navbar-menu"
          // $el.classList.toggle('is-active')
          $target.classList.remove('is-active')
          // Toggle on navbarBurger
          $navbarBurgers.forEach(function ($el) {
            if ($el.classList.contains('is-active')) {
              $el.classList.remove('is-active')
            }
          })
        }
      })
    })
  }
})

export default {
  name: 'TheHeader',
  components: { NavigationMenu }
}
</script>

<style lang="scss">
  @import "../../sass/config";

  .navbar {
    background: transparent;
    padding: 0;
    .navbar-dropdown .is-subitem {
      text-transform: uppercase;
      color: $white;
    }
    > .container {
      padding: 0;
      .navbar-menu {
        margin: 0;
        a.navbar-item:hover,
        a.navbar-item.is-active,
        .navbar-link:hover,
        .navbar-link.is-active {
          text-decoration: none;
        }
      }
      .navbar-brand {
        padding: 0;
        margin: 0;
      }
    }

    .dropdown-trigger .navbar-item {
      color: inherit;
      background-color: inherit;
      &:hover,
      &.is-active {
        background-color: darken($primary, 5%);
        color: $primary-invert
      }
    }

    a {
      .icon {
        height: 100%;
      }
    }

    .navbar-burger {
      span {
        background-color: $white;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/TheHeader.vue